"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash.omit"));

var _reactBeautifulDnd = require("react-beautiful-dnd");

var _DroppableShotsArea = _interopRequireDefault(require("./DroppableShotsArea"));

var _AspectRatioSelector = _interopRequireDefault(require("./AspectRatioSelector/AspectRatioSelector"));

var _ReadOnlyShot = _interopRequireDefault(require("./ReadOnlyShot"));

var _ShotActions = _interopRequireDefault(require("../contexts/ShotActions"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function getTemplateShots(template) {
  return _react.default.createElement("div", {
    className: "shot-list shot-list--template column"
  }, template.shots.map(function (shot, index) {
    return _react.default.createElement(_ReadOnlyShot.default, (0, _extends2.default)({
      key: shot.shotId || shot.tempId,
      index: index
    }, shot));
  }));
}

var ShotList = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ShotList, _Component);

  function ShotList() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, ShotList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(ShotList)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getShotIndex", function (shotId) {
      var shots = _this.props.shots;
      return shots.findIndex(function (shot) {
        var id = shot.shotId || shot.tempId;
        return shotId === id;
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "deleteShot", function (shotId) {
      return function () {
        var _this$props = _this.props,
            shots = _this$props.shots,
            updateShots = _this$props.updateShots;
        var updatedShots = (0, _toConsumableArray2.default)(shots);

        var shotIndex = _this.getShotIndex(shotId);

        if (shotIndex === -1) {
          return;
        }

        updatedShots.splice(shotIndex, 1);
        updateShots(updatedShots);
      };
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "duplicateShot", function (shotId) {
      return function () {
        var _this$props2 = _this.props,
            shots = _this$props2.shots,
            updateShots = _this$props2.updateShots;
        var updatedShots = shots.slice(0);

        var shotIndex = _this.getShotIndex(shotId);

        if (shotIndex === -1) {
          return;
        }

        updatedShots.splice(shotIndex, 0, _objectSpread({}, (0, _lodash.default)(shots[shotIndex], ['shotId']), {
          tempId: Date.now()
        }));
        updateShots(updatedShots);
      };
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updateShot", function (shotId) {
      return function (changes) {
        var _this$props3 = _this.props,
            shots = _this$props3.shots,
            updateShots = _this$props3.updateShots;
        var updatedShots = (0, _toConsumableArray2.default)(shots);

        var shotIndex = _this.getShotIndex(shotId);

        if (shotIndex === -1) {
          return;
        }

        updatedShots.splice(shotIndex, 1, _objectSpread({}, shots[shotIndex], {}, changes));
        updateShots(updatedShots);
      };
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "createShot", function () {
      var assetId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''; // TODO: scroll to shot

      var _this$props4 = _this.props,
          shots = _this$props4.shots,
          updateShots = _this$props4.updateShots;
      updateShots([].concat((0, _toConsumableArray2.default)(shots), [{
        tempId: Date.now(),
        script: '',
        assetId: assetId
      }]));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onDragEnd", function (result) {
      var _this$props5 = _this.props,
          shots = _this$props5.shots,
          updateShots = _this$props5.updateShots,
          selectShot = _this$props5.selectShot;

      if (!result.destination) {
        return;
      }

      var updatedShots = shots.slice(0);

      var _updatedShots$splice = updatedShots.splice(result.source.index, 1),
          _updatedShots$splice2 = (0, _slicedToArray2.default)(_updatedShots$splice, 1),
          removed = _updatedShots$splice2[0];

      updatedShots.splice(result.destination.index, 0, removed);
      selectShot(result.destination.index)();
      updateShots(updatedShots);
    });
    return _this;
  }

  (0, _createClass2.default)(ShotList, [{
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          shots = _this$props6.shots,
          template = _this$props6.template,
          aspectRatio = _this$props6.aspectRatio,
          selectShot = _this$props6.selectShot,
          handleStoryboardFieldChange = _this$props6.handleStoryboardFieldChange,
          selectedShotIndex = _this$props6.selectedShotIndex,
          hasDeletePermission = _this$props6.hasDeletePermission,
          storyboardPermissions = _this$props6.storyboardPermissions,
          hasUpdatePermission = _this$props6.hasUpdatePermission;

      if (template) {
        return getTemplateShots(template);
      }

      return _react.default.createElement(_reactBeautifulDnd.DragDropContext, {
        onDragEnd: this.onDragEnd
      }, _react.default.createElement("div", {
        className: "shot-list"
      }, _react.default.createElement(_AspectRatioSelector.default, {
        aspectRatio: aspectRatio,
        handleStoryboardFieldChange: handleStoryboardFieldChange
      }), _react.default.createElement("div", {
        className: "shot-list__inner column"
      }, _react.default.createElement(_ShotActions.default.Provider, {
        value: {
          createShot: this.createShot,
          updateShot: this.updateShot,
          deleteShot: this.deleteShot,
          duplicateShot: this.duplicateShot,
          selectShot: selectShot,
          hasDeletePermission: hasDeletePermission
        }
      }, _react.default.createElement(_DroppableShotsArea.default, {
        shots: shots,
        aspectRatio: aspectRatio,
        selectedShotIndex: selectedShotIndex,
        storyboardPermissions: storyboardPermissions,
        hasUpdatePermission: hasUpdatePermission
      })))));
    }
  }]);
  return ShotList;
}(_react.Component);

var _default = ShotList;
exports.default = _default;